import { gql } from '@apollo/client';

export const GET_BANK_LINK_TOKEN = gql`
  query getBankLinkToken($input: GetBankLinkTokenInput) {
    getBankLinkToken(input: $input) {
      provider
      token
    }
  }
`;
